// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__25dxn","header":"ReportDetails_header__1ZCNB","title":"ReportDetails_title__1zS72","left":"ReportDetails_left__F7tC8"};